import { visualSweepsConfig } from '@labrain/engine-staircase';
export const staircaseConfig = {
    ...visualSweepsConfig,
    gameSlug: 'hawk-eye',
    category: 'air_attention',
    startValue: 250,
    minValue: 17,
    maxValue: 600,
    maxTrials: 24,
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
};
/** 8 positions horloge (cardinales + diagonales) en degrés depuis le haut. */
export const SECTOR_ANGLES = [0, 45, 90, 135, 180, 225, 270, 315];
/** Symboles cibles — différents pour ne pas créer de pop-out trivial. */
export const TARGET_SYMBOLS = ['◆', '●', '▲', '★'];
function buildVariant(level) {
    if (level <= 10) {
        return { level, nDistractors: 0, eccentricity: '10deg', hardDistractors: false, label: 'Recherche libre' };
    }
    if (level <= 20) {
        return { level, nDistractors: 3, eccentricity: '20deg', hardDistractors: false, label: 'Filtrage' };
    }
    if (level <= 30) {
        return { level, nDistractors: 5, eccentricity: '30deg', hardDistractors: false, label: 'UFOV étendu' };
    }
    if (level <= 40) {
        return { level, nDistractors: 5, eccentricity: '30deg', hardDistractors: true, label: 'Distracteurs proches' };
    }
    return { level, nDistractors: 7, eccentricity: '30deg', hardDistractors: true, label: 'Champ entier saturé' };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
export const eccentricityRadiusPx = {
    '10deg': 90,
    '20deg': 130,
    '30deg': 160,
};
export const timing = {
    fixationMs: 600,
    maskMs: 200,
    itiMs: 700,
    minRenderMs: 17,
};
export const paradigmMeta = {
    slug: 'hawk-eye',
    paradigm: 'UFOV-1 (Ball & Owsley) — visual search périphérique',
    masterMage: 'Inori (attention-air)',
    category: 'air_attention',
    goal: 'Élargir le champ utile — repérer cible en périphérie sous flash bref.',
};
//# sourceMappingURL=params.js.map